import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { TokenService } from 'src/app/shared/services/token.service';

@Injectable({
  providedIn: 'root'
})
export class PreventGuard implements CanActivate {
  constructor(
    private _router: Router,
    private auth: AuthService,
    private tokenService: TokenService
  ) {
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const logoutPaths = ['/auth/logout-all-session', '/logout-all-session', '/auth/logout-all-products'];
      const isLoginWithCode = next.routeConfig?.path === 'login' && !!next.queryParams['code'];

      if (isLoginWithCode) {
        this.tokenService.destroy();
        return true;
      }

      if (this.auth.isAuthenticated() && !logoutPaths.includes(window.location.pathname)) {
        this._router.navigate([`dashboard`]);
        return false;
      }else{
        this.auth.loginIndicator.next(0);
      }
      return true;
  }
  
}
